import React, { useState, useContext, useEffect } from 'react';
import { Button, Typography, TextField, Box, Slider } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { AuthContext } from '../AuthContextProvider';
import { useNavigate } from 'react-router-dom';
import { rpc } from '../utils/RpcUtils';
import * as Constants from '../Constants';
import '../App.css';

const User = () => {
  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [volume, setVolume] = useState(Constants.DEFAULT_VOLUME);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const onFetchSuccess = (user) => {
      setLastName(user.last);
      setFirstName(user.first);
      setEmail(user.email);
      setPhone(user.phone);
      setVolume(user.volume);
    };

    const fetchUser = async () => {
      const params = {
        _id: user._id,
      };
      rpc({
        method: 'GetUser',
        params,
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: onFetchSuccess
      });
    };
    fetchUser();
  }, [user]);

  const onSuccess = () => {
    navigate('/home');
  };

  const updateUser = async () => {
    if (phone === '' || lastName === '' || firstName === '' || email === '') {
      setErrorMessage('All fields except Password are required');
      setOpenErrorDialog(true);
      return;
    }
    const params = {
      _id: user._id,
      last: lastName,
      first: firstName,
      email,
      phone,
      volume
    };
    if (password !== '') {
      params.password = password;
    }
    rpc({
      method: 'UpdateUser',
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess
    });
  };

  const handleVolumeChange = (event, newValue) => {
    setVolume(newValue);
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  return (
    <div className="UserDetails">
      <Typography variant="h6" gutterBottom>
        User Details
      </Typography>
      <TextField className="TextField"
        label="Login"
        value={email}
        size="small"
        onChange={(e) => setEmail(e.target.value)}
        onBlur={() => setEmail(email.trim())}
      />
      <TextField className="TextField"
        label="Password"
        type="password"
        value={password}
        size="small"
        onChange={(e) => setPassword(e.target.value)}
        onBlur={() => setPassword(password.trim())}
      />
      <TextField className="TextField"
        label="Phone"
        value={phone}
        size="small"
        onChange={(e) => setPhone(e.target.value)}
        onBlur={() => setPhone(phone.trim())}
      />
      <TextField className="TextField"
        label="Last Name"
        value={lastName}
        size="small"
        onChange={(e) => setLastName(e.target.value)}
      />
      <TextField className="TextField"
        label="First Name"
        value={firstName}
        size="small"
        onChange={(e) => setFirstName(e.target.value)}
      />
      <Box sx={{ width: 300, px: 2, py: 1 }}>
        <Typography id="input-slider" gutterBottom>
          Tablet Volume ({volume}%)
        </Typography>
        <Slider
          value={volume}
          onChange={handleVolumeChange}
          aria-labelledby="input-slider"
          valueLabelDisplay="auto"
          step={1}
          min={0}
          max={100}
        />
      </Box>
      <Button className="Button" variant="contained" color="primary" onClick={updateUser}>
        Update
      </Button>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default User;
